/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';

/*Import Requisição API*/
import api from '../../../../api';
import { useToast } from '../../../../context/ToastContext';

export default function EditarCupom() {
    const navigate = useNavigate();
    const location = useLocation();
    const id_cupom = location.state?.id;
    const { showToast } = useToast();

    const [codigo, setCodigo] = useState('');
    const [descricao, setDescricao] = useState('');
    const [tipoDesconto, setTipoDesconto] = useState('percentage');
    const [valorDesconto, setValorDesconto] = useState('');
    const [usoMaximo, setUsoMaximo] = useState('');
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [ativo, setAtivo] = useState(true);
    const [loading, setLoading] = useState(false);

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    const buscarCupom = useCallback(async () => {
        try {
            const response = await api.get(`/cupom/${id_cupom}`, { withCredentials: true });
            if (response.data.success) {
                const cupom = response.data.data;
                setCodigo(cupom.codigo);
                setDescricao(cupom.descricao || '');
                setTipoDesconto(cupom.tipo_desconto);
                setValorDesconto(cupom.valor_desconto.toString());
                setUsoMaximo(cupom.uso_maximo ? cupom.uso_maximo.toString() : '');
                setDataInicio(cupom.data_inicio ? cupom.data_inicio.substring(0, 16) : '');
                setDataFim(cupom.data_fim ? cupom.data_fim.substring(0, 16) : '');
                setAtivo(cupom.ativo);
            }
        } catch (error) {
            showToast('Erro ao carregar cupom', 'error');
            navigate('/menu/cupons');
        }
    }, [id_cupom, navigate, showToast]);

    useEffect(() => {
        if (id_cupom) {
            buscarCupom();
        }
    }, [id_cupom, buscarCupom]);

    const enviarEditarCupom = async (e) => {
        e.preventDefault();

        if (!codigo.trim()) {
            showToast('Código é obrigatório', 'error');
            return;
        }

        if (!valorDesconto || valorDesconto <= 0) {
            showToast('Valor do desconto deve ser maior que 0', 'error');
            return;
        }

        if (tipoDesconto === 'percentage' && valorDesconto > 100) {
            showToast('Percentual não pode ser maior que 100%', 'error');
            return;
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);

        try {
            const response = await api.put(`/cupom/${id_cupom}`, {
                codigo: codigo.toUpperCase(),
                descricao,
                tipo_desconto: tipoDesconto,
                valor_desconto: parseFloat(valorDesconto),
                uso_maximo: usoMaximo ? parseInt(usoMaximo) : null,
                data_inicio: dataInicio || null,
                data_fim: dataFim || null,
                ativo
            }, { withCredentials: true });

            if (response.data.success) {
                navigate(`/menu/cupom`);
                showToast('Cupom atualizado com sucesso!', 'success');
            } else {
                setTexto(response.data.message || 'Erro ao atualizar cupom');
                abrirModalAviso();
            }
        } catch (error) {
            setTexto(error.response?.data?.message || 'Erro ao atualizar cupom');
            abrirModalAviso();
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="container-principal-editar-cupom">

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className="conteudo-editar-cupom">
                    <div className="titulo-perfil">
                        <h1><span>Cupons</span> &gt; Edição de Cupom</h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <div className='perfil-editar-cupom'>
                        <h2>Edite os dados do cupom</h2>
                        <form className="form-editar-cupom" onSubmit={enviarEditarCupom}>
                            <label>Código: <span className='span-obrigatorio'>*</span></label>
                            <div className='input-codigo'>
                                <input
                                    type="text"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                                    maxLength={50}
                                    placeholder="Digite o código do cupom"
                                    required
                                />
                            </div>

                            <label>Descrição (opcional):</label>
                            <div className='input-descricao'>
                                <textarea
                                    value={descricao}
                                    onChange={(e) => setDescricao(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite a descrição do cupom"
                                />
                            </div>

                            <label>Tipo de Desconto: <span className='span-obrigatorio'>*</span></label>
                            <div className='input-tipoDesconto'>
                                <select
                                    value={tipoDesconto}
                                    onChange={(e) => setTipoDesconto(e.target.value)}
                                    required
                                >
                                    <option value="percentage">Percentual (%)</option>
                                    <option value="fixed">Valor Fixo (R$)</option>
                                </select>
                            </div>

                            <label>Valor do Desconto: <span className='span-obrigatorio'>*</span></label>
                            <div className='input-valorDesconto'>
                                <input
                                    type="number"
                                    value={valorDesconto}
                                    onChange={(e) => setValorDesconto(e.target.value)}
                                    step="0.01"
                                    placeholder="Digite o valor do desconto"
                                    required
                                />
                            </div>

                            <label>Uso Máximo (opcional):</label>
                            <div className='input-usoMaximo'>
                                <input
                                    type="number"
                                    value={usoMaximo}
                                    onChange={(e) => setUsoMaximo(e.target.value)}
                                    placeholder="Deixe em branco para ilimitado"
                                />
                            </div>

                            <label>Data de Início (opcional):</label>
                            <div className='input-dataInicio'>
                                <input
                                    type="datetime-local"
                                    value={dataInicio}
                                    onChange={(e) => setDataInicio(e.target.value)}
                                />
                            </div>

                            <label>Data de Fim (opcional):</label>
                            <div className='input-dataFim'>
                                <input
                                    type="datetime-local"
                                    value={dataFim}
                                    onChange={(e) => setDataFim(e.target.value)}
                                />
                            </div>

                            <label>Status: <span className='span-obrigatorio'>*</span></label>
                            <div className='input-ativo'>
                                <select value={ativo ? 'sim' : 'nao'} onChange={(e) => setAtivo(e.target.value === 'sim')}>
                                    <option value="sim">Ativo</option>
                                    <option value="nao">Inativo</option>
                                </select>
                            </div>

                            <button className='bnt-editar-cupom' type="submit" disabled={loading}>
                                {loading ? 'Salvando...' : 'Salvar Alterações'}
                            </button>
                        </form>
                    </div>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
